// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import friendlyTimeFormatter from '../../../../../../../../common/utils/datetime/friendlyTimeFormatter';
import { getGivenName } from '../../../../../../../../common/users/userHelper';

// Components
import UserAvatar from '../../../../../../../components/userAvatar/UserAvatar';

// Constants
import { USER_AVATAR_SIZES } from '../../../../../../../../common/users/userConstants';

// Styles
import './PublishBoardViewerEntry.scss';

const PublishBoardViewerEntry = (props) => {
    const { viewer, lastView, type } = props;

    const lastViewFormattedTime = friendlyTimeFormatter({
        timestamp: lastView,
        lessThanMinuteMessage: 'just now',
        showSuffix: true,
    });

    const name = type === 'VIEWER' ? getGivenName(viewer) : 'Guest user';

    return (
        <div className="PublishBoardViewerEntry">
            <div className="user-details">
                <UserAvatar size={USER_AVATAR_SIZES.REGULAR_SMALL} user={viewer} />
                <div className="given-name">{name}</div>
            </div>
            <span className="view-time">{lastViewFormattedTime}</span>
        </div>
    );
};

PublishBoardViewerEntry.propTypes = {
    viewer: PropTypes.object,
    type: PropTypes.string,
    lastView: PropTypes.number,
};

export default PublishBoardViewerEntry;
